export default "__VITE_ASSET__6OLupJRO__"